import { UserType } from "../../../graphql/types";

const recognizedDashboardUserTypes = new Set<UserType>([
  UserType.ChamberAdmin,
  UserType.ChamberStaff,
  UserType.ChamberMemberAdmin,
]);

export const getSingleDashboardUserType = (
  tokenPayload?: Record<string, unknown> | null
): UserType | null => {
  const groups = tokenPayload?.["cognito:groups"];
  if (!Array.isArray(groups) || groups.length !== 1) {
    return null;
  }

  const [group] = groups;
  if (
    typeof group !== "string" ||
    !recognizedDashboardUserTypes.has(group as UserType)
  ) {
    return null;
  }

  return group as UserType;
};
